import { Content } from '@prismicio/client';
import { SliceComponentProps } from '@prismicio/react';
import { PrismicNextImage } from '@prismicio/next';
import { PrismicRichText } from '@prismicio/react';
import SocialLinkIcon from '@/components/aboutUs/SocialLinksWithIcons';

/**
 * Props for `TeamLeadershipGrid`.
 */
export type TeamLeadershipGridProps =
  SliceComponentProps<Content.TeamLeadershipGridSlice>;

/**
 * Component for "TeamLeadershipGrid" Slices.
 */
const TeamLeadershipGrid = ({
  slice,
}: TeamLeadershipGridProps): JSX.Element => {
  const {
    primary: { heading, members },
  } = slice;
  return (
    <section
      data-slice-type={slice.slice_type}
      data-slice-variation={slice.variation}
      className="py-12 md:py-16 lg:py-20 bg-white"
    >
      <div className="container mx-auto px-4 md:px-6 text-black">
        <div className="flex flex-col items-center gap-y-8 px-8 md:px-0 text-center">
          <div
            className="font-bold text-3xl sm:text-4xl md:text-5xl leading-tight max-w-3xl"
            style={{
              fontWeight: '700',
              fontSize: '40px',
              lineHeight: '120%',
            }}
          >
            <PrismicRichText field={heading} />
          </div>

          <div className="flex flex-row flex-nowrap overflow-x-auto no-scrollbar gap-x-6 md:gap-x-1 w-full pt-8 pb-4 md:justify-center">
            {members.map((item, index) => (
              <div
                className="flex flex-col items-start gap-y-4 md:gap-y-5 w-72 md:w-60 flex-shrink-0 bg-white p-6"
                key={`leader-card-${index}`}
              >
                <div className="w-full overflow-hidden rounded-full border-2 border-primary-shade-green mx-auto">
                  <PrismicNextImage
                    field={item.photo}
                    className="w-full h-full object-cover"
                  />
                </div>
                <div className="flex flex-col justify-center items-center gap-y-4 md:gap-y-5 w-full flex-shrink-0 bg-white">
                  <div className="flex flex-col justify-center">
                    <span
                      style={{
                        fontWeight: '700',
                        fontSize: '18px',
                        lineHeight: '28px',
                      }}
                    >
                      {item.name}
                    </span>
                    <span
                      style={{
                        fontWeight: '500',
                        fontSize: '14px',
                        lineHeight: '25px',
                        color: '#19191B',
                      }}
                    >
                      {item.role}
                    </span>
                  </div>

                  <div className="flex flex-row gap-x-3 justify-center">
                    {item.social_links.map((link, index) => (
                      // Custom Component to show Social Icon depending on the Social Link
                      <div key={`social-logo-${index}`}>
                        <SocialLinkIcon linkField={link} />
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default TeamLeadershipGrid;
